import { render, staticRenderFns } from "./VocationsForm.vue?vue&type=template&id=49768e2e&"
import script from "./VocationsForm.vue?vue&type=script&lang=js&"
export * from "./VocationsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports